import {
  DETAIL_GET_COMMENT_LIST_SUCCESS,
  DETAIL_GET_GRADE_SUCCESS,
  DETAIL_ADD_COMMENT_SUCCESS,
  DETAIL_ADD_ZAN_SUCCESS,
  USER_SCORE_FORSTORE_SUCCESS,
} from '../constants/comment';

const initState = {
  commentList: {},
  grade: {},
  addComment: {
    inLoadding: false,
  },
  addZan: {},
  userScoreForStore: {},
};

const comment = (state = initState, action = {}) => {
  switch (action.type) {
    case DETAIL_GET_COMMENT_LIST_SUCCESS:
      return { ...state, commentList: action.payload };
    case DETAIL_GET_GRADE_SUCCESS:
      return { ...state, grade: action.payload };
    case DETAIL_ADD_COMMENT_SUCCESS:
      return { ...state, addComment: action.payload };
    case DETAIL_ADD_ZAN_SUCCESS:
      return { ...state, addZan: action.payload };
    case USER_SCORE_FORSTORE_SUCCESS:
      return { ...state, userScoreForStore: action.payload };
    default:
      return state;
  }
};

export default comment;
